<?xml version="1.0" encoding="UTF-8"?>
<svg width="23px" height="23px" viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Zoom-in" transform="translate(3.000000, 0.000000)" stroke="#FA6A95">
            <line x1="0" y1="19.3453646" x2="5.36916203" y2="14.0740741" id="Path-4" stroke-width="3" stroke-linecap="round"></line>
            <path d="M8,8.50354968 L14.0717327,8.50354968" id="Combined-Shape" stroke-width="2" stroke-linecap="round"></path>
            <circle id="Oval" stroke-width="2.5" cx="10.9247176" cy="8.51851852" r="7.26851852"></circle>
        </g>
    </g>
</svg>